var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},""),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Mobile","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Talk-to-sales-Mobile-Email-04","transform":"translate(-324.000000, -214.000000)","fill":"#000000","fillRule":"nonzero"},React.createElement("g",{"id":"Group-38","transform":"translate(310.000000, 200.000000)"},React.createElement("polygon",{"id":"","points":"22 32.3125 38 16.3125 36.1875 14.4375 22 28.625 16.4375 23 14.5625 24.875"}))))]);
}

CheckInline.defaultProps = {"width":"24px","height":"19px","viewBox":"0 0 24 19","version":"1.1"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
